import React from "react";

// Customizable Area Start
import {
  Box, Grid, Typography,
  Card, CardContent, CardMedia
} from "@mui/material";
import {
  StyledEngineProvider,
} from "@mui/material/styles";
import { videoPauseimg, qrcode, rightArrow, leftArrow, downArrow, marketingImage } from "./assets";
import Header from "./Header.web";
import Footer from "./Footer.web";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToScroll: 1,
  autoplay: false,
  arrows: false,
  swipe: true,
  draggable: true,
};

// Customizable Area End

import LandingPageController, {
  Props,
  configJSON,
} from "./LandingPageController";

export default class LandingPage extends LandingPageController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start
 

  render() {
    return (
      // Customizable Area Start
      <StyledEngineProvider injectFirst>
        <Box sx={{overflowX: "hidden", scrollSnapType: "y mandatory"}}>
        <Box>
        <Box id="home-section" style={{ scrollSnapAlign: "start" }}>
        <Header navigation={this.props.navigation} id={""} />
          <Box
            sx={{
              bgcolor: "#f0f0f0",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
              overflow: "hidden",
              height: "100vh",
            }}
          >
            <video
              ref={this.videoRef}
              src="https://www.w3schools.com/html/mov_bbb.mp4"
              onEnded={this.handleVideoEnd}
              width="100%"
              height="100%"
              style={{
                objectFit: "cover",
                border: "none",
                outline: "none",
              }}
            >
              Your browser does not support the video tag.
            </video>

            {/* Custom Play Button */}
            {!this.state.videoPlaying && (
              <Box
              data-test-id="videoPlaying"
              onClick={this.handlePlayPause}
                sx={{
                  position: "absolute",
                  transform: "translate(-50%, -50%)",
                  bgcolor: "transparent",
                  borderRadius: "50%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                  cursor: "pointer",
                  left: "50%",
                  top: "50%"
                }}
              >
                <img
                  src={videoPauseimg}
                  alt="Play"
                  style={{
                    width: "97.5px",
                    height: "97.5px",
                    objectFit: "contain",
                  }}
                />
              </Box>
            )}

            {/* Scroll Down Button */}
            <Box
            onClick={this.scrollToConnectSection}
             data-test-id="firstScroll"
              sx={{
                position: "absolute",
                bottom: "20px",
                bgcolor: "transparent",
                width: "56px",
                height: "56px",
                borderRadius: "50%",
                left: "50%",
                transform: "translateX(-50%)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center", border: "2px solid white",
                cursor: "pointer",
              }}
            >
              <img
                src={downArrow}
                alt="Scroll Down"
                style={{
                  width: "19.96px",
                  height: "11.73px",
                  objectFit: "contain",

                }}
              />
            </Box>
          </Box>
         </Box>
          
          <Box
          id="connect-section"
          style={{ scrollSnapAlign: "start" }}
            sx={{
              height: "90vh",
              bgcolor: "#121212", 
              color: "#fff", 
              padding: { xs: "40px 20px", sm: "100px 80px", md: "150px 160px" }

            }}
          >
            <Grid container spacing={2} alignItems="stretc">
              <Grid item xs={12} md={4}>
                <Box sx={{ display: "flex", flexDirection: "column", height: "100%", justifyContent: "space-between", }}>
                  <Box sx={{paddingBottom:"40px"}}>
                  <Typography sx={{ fontSize: "clamp(40px, 5vw, 100px)",
                    fontWeight: 700,
                    fontFamily: "var(--font-family-inter)",
                    lineHeight: "80px"}}>
                    {configJSON.connectText}
                  </Typography>
                  </Box>
                  <Typography  sx={webStyle.responsiveBox}
                >
                    {this.state.connectSectionData?.data[0]?.connect_subtext}
                  </Typography>
                  <Box sx={{ bottom: "24px" }}>
                    <Box
                      onClick={this.scrollToPitchSection}
                      data-test-id="secondScroll"
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "100px",
                        width: "56px",
                        height: "56px",
                        borderRadius: "50%",
                        border: "2px solid white",
                        cursor: "pointer",
                        alignSelf: "flex-end",
                        mt: "auto",
                        left: "50%",
                transform: "translateX(-50%)",
                      }}
                    >
                      <img
                        src={downArrow}
                        alt="Scroll Down"
                        style={{
                          width: "19.96px",
                  height: "11.73px",
                          objectFit: "contain",
                        }}
                      />
                    </Box>
                  </Box>
                </Box>
              </Grid>

              <Grid item xs={12} md={8}>
                <Box
                  sx={{
                    width: "100%",
                    bgcolor: "#f0f0f0",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "relative",
                    overflow: "hidden",
                    height: "100%",
                    borderRadius: "10px",
                  }}
                >
                  <video
                    ref={this.videoRef1}
                    src={this.state.connectSectionData.data[0]?.video_url.replace("redirect", "proxy")}
                    width="100%"
                    height="100%"
                    onEnded={this.handleVideoEnd1}
                    style={{
                      objectFit: "cover",
                      maxHeight: "90vh",
                      border: "none",
                      outline: "none",
                    }}
                  >
                    Your browser does not support the video tag.
                  </video>

                  {/* Custom Play Button */}
                  <Box
                    onClick={this.handlePlayPause1}
                    sx={{
                      position: "absolute",
                      transform: "translate(-50%, -50%)",
                      bgcolor: "transparent",
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                      cursor: "pointer",
                      top: "50%",
                      left: "50%",
                    }}
                    data-test-id="handlepalypause"
                  >
                    {!this.state.videoPlaying1 && (
                    <img
                      src={videoPauseimg}
                      alt="Play"
                      style={{
                        width: "97.5px",
                        height: "97.5px",
                        objectFit: "contain",
                      }}
                    />
                  )}
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
           
           
          <Box
          style={{ scrollSnapAlign: "start" }}
          id="pitch-section"
            sx={{
              height: "100vh",
              bgcolor: "#f0f0f0",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* Video Without Controls */}
            <video
              ref={this.videoRef2}
              src={this.state.pitchSectionData?.data[0]?.video_url.replace("redirect", "proxy")}
              width="100%"
              height="auto"
              onEnded={this.handleVideoEnd2}
              style={{
                objectFit: "cover",
                maxHeight: "100vh",
                height: "100%",
                border: "none",
                outline: "none",
              }}
            >
              Your browser does not support the video tag.
            </video>
            <Box
              sx={{
                position: "absolute",
                top: "64px",
                left: "160px",
                textAlign: "left",
                maxWidth: "100%",
                width: "50px"
              }}
            >
              <Box sx={{
    marginBottom: "40px", 
    "@media (min-width: 600px)": {
      marginBottom: "80px", 
    },
    "@media (min-width: 960px)": {
      marginBottom: "100px", 
    },
    "@media (min-width: 1280px)": {
      marginBottom: "129px", 
    },
  }}>
              <Typography sx={{ color: "white", fontSize: "clamp(20px, 5vw, 40px)", fontWeight: "bold", lineHeight: "clamp(20px, 5vw, 40px)" }}>
                Video
              </Typography> 
              </Box>
              <Typography
                sx={{
                  color: "white",
                  fontSize: "clamp(40px, 5vw, 100px)",
                  lineHeight: "clamp(40px, 5vw, 100px)",
                  fontWeight: "bold", marginTop: "40px"
                }}
              >
                Hubblemeet Pitch
              </Typography>
            </Box>
            <Box
              sx={{
                position: "absolute",
                bottom: "0px", 
                right: "0px", width: { xs: "90%", sm: "80%", md: "50%", lg: "40%", xl: "43%" },
                height: { xs: "auto", sm: "auto", md: "20%", lg: "25%", xl: "32%" },
                maxWidth: {
                  xs: "100%",  
                  sm: "100%",  
                  md: "86%",  
                  lg: "61%",   
                  xl: "40%",  
                },
                bgcolor: "#121212", 
                color: "white",
                padding: { xs: "20px", sm: "30px", md: "40px", lg: "60px" }, 
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                borderTopLeftRadius: "8px",
                boxShadow: "0px 4px 10px rgba(0,0,0,0.2)", 
              }}
            >
              <Typography
                sx={{
                  font: "inter",
                  fontSize: { xs: "14px", sm: "16px", md: "24px", lg: "24px" },
                  lineHeight: { xs: "22px", sm: "24px", md: "32px", lg: "32px" },
                  letterSpacing: "-0.5%",
                  fontWeight: 400,
                }}
              >
                {this.state.pitchSectionData?.data[0]?.pitch_subtext}
              </Typography>

              <Box
              onClick={this.scrollToTestimonialSection}
               data-test-id="thirdScroll"
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "16px",
                  width: "56px",
                  height: "56px",
                  borderRadius: "50%",
                  border: "2px solid white",
                  cursor: "pointer",
                  alignSelf: "flex-end",
                  left: "50%",
                transform: "translateX(-50%)",
                }}
              >
                <img
                  src={downArrow}
                  alt="Scroll Down"
                  style={{
                    width: "19.96px",
                    height: "11.73px",
                    objectFit: "contain",
                  }}
                />
              </Box>
            </Box>


            {/* Custom Play Button */}
            {!this.state.videoPlaying2 && (
              <Box
              onClick={this.handlePlayPause2}
              data-test-id="videoPlaying"
                sx={{
                  position: "absolute",
                  transform: "translate(-50%, -50%)",
                  bgcolor: "transparent",
                  borderRadius: "50%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                  cursor: "pointer",
                  left: "50%",
                  top: "50%",
                }}               
              >
                <img
                  src={videoPauseimg}
                  alt="Play"
                  style={{
                    width: "97.5px",
                    height: "97.5px",
                    objectFit: "contain",
                  }}
                />
              </Box>
            )}
          </Box>
          {this.state.testimonialsData.data.length > 0 && (
           <Box id="testimonial-section" sx={{position: "relative", scrollSnapAlign: "start"}}>
          <Box paddingX={14} paddingY={12} sx={{ backgroundColor: "black" }}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="flex-start"
              gap={2}
              flexWrap="wrap"
            >
              <Box
                width="45%"
                textAlign="left"
                p={3}
                borderRadius="8px"
                color="#fff"
                sx={{ backgroundColor: "black", gap: "10px" }}
                height="100%" 
              > 
              <Box sx={{paddingBottom:"40px"}}>
                <Typography
                  sx={{
                    fontSize: "clamp(40px, 5vw, 100px)",
                    fontWeight: 700,
                    fontFamily: "var(--font-family-inter)",
                    lineHeight: "80px"
                  }}
                >
                  Testimonials
                </Typography> 
                </Box>
                <Typography
                  sx={{
                    fontSize: "32px",
                    fontWeight: "400",
                    fontFamily: "var(--font-family-inter)",
                    lineHeight: "40px",
                    font: "inter",
                    letterSpacing: "0%",
                  }}
                >
                  Forem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                  vulputate libero et velit interdum, ac aliquet odio mattis.
                </Typography>
              </Box>
              <Box
                bgcolor="black"
                borderRadius="8px"
                display="flex"
                justifyContent="center"
                alignItems="center"
                flexDirection="column"
              >
                <img
                  src={qrcode}
                  alt="QR Code"
                  style={{
                    width: "100%",
                    height: "100%",
                    maxWidth: "238px",
                    objectFit: "contain",
                  }}
                />
                <Typography
    sx={{
      color: "#fff",
      textAlign: "center",
      marginTop: "10px",
      fontSize: "16px",
      fontWeight: 400,
      fontFamily: "var(--font-family-inter)",
    }}
  >
    Scan here to download the app
  </Typography>
              </Box>
              <Box
                width="5%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="flex-end"
                bgcolor="black"
                textAlign="center"
                borderRadius="8px"
                color="#fff"
              >
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="end"
                  width="100%"
                  height="234px"
                >
                  <img
                  data-test-id = "leftArrow"
                  onClick={this.handleLeftArrowClick}
                    src={leftArrow}
                    alt="Left Arrow"
                    style={{
                      width: "30px",
                      height: "30px",
                      marginRight:"30px"
                    }}
                  />
                  <img
                  data-test-id = "rightArrow"
                  onClick={this.handleRightArrowClick}
                    src={rightArrow}
                    alt="Right Arrow"
                    style={{
                      width: "30px",
                      height: "30px",
                    }}
                  />
                </Box>
              </Box>
            </Box>
          </Box> 
          <Grid container justifyContent="center">
            <Grid item xs={12}>
              <Box p={4} sx={{bgcolor:"black"}}>
                <Slider
                ref={this.sliderRef}
                beforeChange={(current, next) => this.setState({ currentSlide: next })}
                 useTransform={false} 
                  {...sliderSettings}
                  slidesToShow={Math.max(1, Math.min(3, this.state.testimonialsData.data.length))}
                  responsive={[
                    {
                      breakpoint: 1920,
                      settings: { slidesToShow: Math.max(1, Math.min(3, this.state.testimonialsData.data.length)) },
                    },
                    {
                      breakpoint: 960,
                      settings: { slidesToShow: Math.max(1, Math.min(2, this.state.testimonialsData.data.length)) },
                    },
                    {
                      breakpoint: 600,
                      settings: { slidesToShow: Math.max(1, Math.min(1, this.state.testimonialsData.data.length)) },
                    },
                  ]}
                >
                  {this.state.testimonialsData.data.map((card: any, index: any) => (
                    <Box key={index} 
                    sx={{ p: 5, display: "flex", justifyContent: "center" }}
                    >
                      <Card
                        sx={{
                                 boxShadow: 1,
                                 bgcolor: "black",
                                 maxWidth: "calc(507px - 20px)",
                                 margin: "0 10px",
                               }}
                      >
                        <CardMedia
                          component="img"
                          alt="image"
                          sx={{ height: { xs: 300, sm: 300, md: 390 } }}
                          image={card.image_url}
                          style={{ objectFit: "cover" }}
                        />
                        <CardContent>
                          <Typography
                            sx={{
                              fontSize: "36px",
                              fontWeight: 700,
                              lineHeight: "44px",
                              fontFamily: "var(--font-family-inter)",
                              color: "white",
                            }}
                          >
                            {card.name}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "18px",
                              fontWeight: 700,
                              lineHeight: "26px",
                              fontFamily: "var(--font-family-inter)",
                              marginBottom: "24px",
                              color: "white",
                            }}
                          >
                            {card.designation}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "22px",
                              fontWeight: 400,
                              fontFamily: "var(--font-family-inter)",
                              lineHeight: "22px",
                              color: "white",
                            }}
                          >
                            {card.content}
                          </Typography>
                        </CardContent>
                      </Card>
                    </Box>
                  ))}
                </Slider>
              </Box>
              
            </Grid>
          </Grid>
          {/* Add Down Arrow Button */}
    <Box
      onClick={this.scrollToMarketingSection}
      sx={{
        position: "relative",
        bottom: "60px",
        left: "50%",
        transform: "translateX(-50%)",
        bgcolor: "transparent",
        width: "56px",
        height: "56px",
        borderRadius: "50%",
        border: "2px solid white",
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img
        src={downArrow}
        alt="Scroll Down"
        style={{
          width: "19.96px",
                  height: "11.73px",
          objectFit: "contain",
        }}
      />
    </Box>
         </Box>
          )}
         {/* Marketing Image Section */}
         <Box id="marketing-section" sx={{position: "relative", scrollSnapAlign: "start"}}>
            <Box
              sx={{
                width: "100vw",
                height: "100vh",
                backgroundImage: `url(${marketingImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                position: "relative",
              }}
            >
            </Box>
            {/* Add Down Arrow Button */}
    <Box
      onClick={this.scrollToFooterSection}
      sx={{
        position: "absolute",
        bottom: "60px",
        left: "50%",
        transform: "translateX(-50%)",
        bgcolor: "transparent",
        width: "56px",
        height: "56px",
        borderRadius: "50%",
        border: "4px solid white",
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img
        src={downArrow}
        alt="Scroll Down"
        style={{
          width: "19.96px",
                  height: "11.73px",
          objectFit: "contain",
        }}
      />
    </Box>
          </Box>
        </Box>
        <Box id="footer-section" sx={{scrollSnapAlign: "start"}}>
        <Footer navigation={this.props.navigation} id={""} footerData={this.state.footerData} />
        </Box>
        </Box>
      </StyledEngineProvider>
      // Customizable Area End
    );
  }
   // Customizable Area End
}

// Customizable Area Start
const webStyle = {
  videoSection: {
    position: "relative",
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
  },
  video: {
    position: "absolute",
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  button: {
    position: "absolute",
    bottom: "20px",
    color: "white",
    background: "rgba(0, 0, 0, 0.5)",
    borderRadius: "50%",
    padding: "10px",
  },
  responsiveBox: {
    marginBottom: "220px",
    fontSize: "32px", 
    fontWeight: 400,
    fontFamily: "var(--font-family-inter)",
    lineHeight: "40px",

    "@media (max-width:1920px)": {
      marginBottom: "180px",
      fontSize: "28px",
      lineHeight: "36px",
    },
    "@media (max-width:1280px)": {
      marginBottom: "140px",
      fontSize: "24px",
      lineHeight: "32px",
    },
    "@media (max-width:960px)": {
      marginBottom: "100px",
      fontSize: "20px",
      lineHeight: "28px",
    },
    "@media (max-width:600px)": {
      marginBottom: "60px",
      fontSize: "16px",
      lineHeight: "24px",
    },
  },
  needMoreInfo:{
    color: "#fff",
    fontWeight: "700",
    fontFamily: "var(--font-family-inter)",
    fontSize: "5vw",
    lineHeight: "5vw",
    margin: "158px 0px 158px 160px",
  
    "@media (max-width: 1920px)": {
      fontSize: "clamp(40px, 5vw, 100px)",
      lineHeight: "clamp(40px, 5vw, 100px)",
      margin: "120px 0px 120px 100px",
    },
  
    "@media (max-width: 1280px)": {
      fontSize: "clamp(36px, 4vw, 80px)",
      lineHeight: "clamp(36px, 4vw, 80px)",
      margin: "100px 0px 100px 80px",
    },
  
    "@media (max-width: 960px)": {
      fontSize: "clamp(32px, 3.5vw, 60px)",
      lineHeight: "clamp(32px, 3.5vw, 60px)",
      margin: "80px 0px 80px 40px",
    },
  
    "@media (max-width: 600px)": {
      fontSize: "clamp(28px, 3vw, 50px)",
      lineHeight: "clamp(28px, 3vw, 50px)",
      margin: "60px 0px 60px 20px",
    },
  }
  
}
// Customizable Area End
